import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { httpOptions, api, serviceConstants, formOptions } from '../../constants/service.constants';
import { Observable } from 'rxjs';
import { SelectValue, Department, SCREEN_RESPONSE, SCREEN_RESPONSE_ANSWER, PolicyModel, ScreenModel } from 'src/app/models/common';
import { FAQ, FAQReorder, Users } from 'src/app/models/um/organization';


@Injectable({
  providedIn: 'root'
})
export class AdministrationSummaryService {

  constructor(private http: HttpClient) { }
  jsonOptions: { responseType: 'json' | undefined, withCredentials: boolean | undefined } = { responseType: "json", withCredentials: true };
  

  getLookupsSummary(_id?): Observable<any> {
    if (_id)
      return this.http.get(serviceConstants.apiURL + 'api/lookup/getlookups/' +  _id, httpOptions);
    else
      return this.http.get(serviceConstants.apiURL + 'api/lookup/getsummary', httpOptions);
  }

  getHLookupsSummary(_id?): Observable<any> {
    if (_id)
      return this.http.get(serviceConstants.apiURL + 'api/lookup/getlookdetails/' + _id, httpOptions);
    else
      return this.http.get(serviceConstants.apiURL + 'api/lookup/gethlookssummary', httpOptions);
  }

  getLookupsAdvSearch(searchObject: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/lookup/getsummary', searchObject, httpOptions);
  }

  getHLookupsAdvSearch(searchObject: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/lookup/getadvancesummaryhlookups', searchObject, httpOptions);
  }


  
  getCCodeSummary(_id?): Observable<any> {
    if (_id) {
      return this.http.get(serviceConstants.apiURL + 'api/autocode/getautocode/' + _id, httpOptions);
    }
    else
      return this.http.get(serviceConstants.apiURL + 'api/autocode/getsummary', httpOptions);
  }

  getAutoCodeSearchSummary(searchObject: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/autocode/getadvsearch', searchObject, httpOptions);
  }

  getEventSummary(_id?): Observable<any> {
    if (_id)
      return this.http.get(serviceConstants.apiURL + 'api/eventmaster/geteventmaster/' + _id, httpOptions);
    else
      return this.http.get(serviceConstants.apiURL + 'api/eventmaster/getsummary', httpOptions);
  }

  getEventSummarySearch(formData: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/eventmaster/getsummarySearch', formData, httpOptions);
  }

  checkValidation(message): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/eventmaster/validatemessage', message, httpOptions);
  }


  saveEventSummary(event: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/eventmaster/update', event, formOptions);
  }

  getRfpSummary(id): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/rfp/getrfpist/" + id, httpOptions);
  }

  getRfpMainSummary(id): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/rfp/fetchrfpsummary/" + id, httpOptions);
  }

  getRFPSearchSummary(searchObject: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/rfp/getadvsearch', searchObject, httpOptions);
  }


  deleteRfp(id: any): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/rfp/delete/" + id, httpOptions);
  }

  changestatusRfp(id: any, changetype : string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/rfp/changestatus/" + id + "/" + changetype, httpOptions);
  }
  

  

  // Screen  methods
  getScreenRepositorySummary(id, moduleName): Observable<any> {
      return this.http.get(serviceConstants.apiURL + "api/screen/getscreenlist/" + id+"/"+moduleName, httpOptions);  
  }

  getScreenRepositorySummaryAdvance(model: ScreenModel): Observable<any> {
    return this.http.post(serviceConstants.apiURL + "api/screen/getscreenlistadvance", model , httpOptions);
  }
  getTemplateSummary(data: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + "api/policy/gettemplatepolicysummary", data, httpOptions);
  }
  getScreenControlsList(id): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/screen/fetchscreencontrols/" + id, httpOptions);
  }
  getModulesList(): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/screen/getmodules/", httpOptions);
  }

  deleteScreen(id: any): Observable<any> {
     ;
    //return this.http.get(url, httpOptions);
    return this.http.get(serviceConstants.apiURL + "api/screen/delete/" + id, httpOptions);
  }
  // Screen controls  methods
  getScreenControlsSummary(id): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/screencontrol/getscreencontrolslist/" + id, httpOptions);
  }
  //////////new code

  faqreordersave(url:any, obj:any): Observable<any>{
  return this.http.post(serviceConstants.apiURL + url, obj, httpOptions); 
      // return this.http.get((serviceConstants.apiURL + url),  httpOptions);
  }
  

  getRecords(url: any) {
     ;
    return this.http.get((serviceConstants.apiURL + url), httpOptions);
  }

  getValues(url: any): Observable<Department[]> {
    return this.http.get<Department[]>((serviceConstants.apiURL + url), httpOptions);
  }

  getDepartments(url: any): Observable<Department[]> {
    return this.http.get<Department[]>((serviceConstants.apiURL + url), httpOptions);
  }
  getMappedRoles(url: any): Observable<any[]> {
    return this.http.get<any[]>((serviceConstants.apiURL + url), httpOptions);
  }
  getDepartmentsMaster(url: any): Observable<any[]> {
    return this.http.get<any[]>((serviceConstants.apiURL + url), httpOptions);
  }
  getUsers(url: any): Observable<Users[]> {
    return this.http.get<Users[]>((serviceConstants.apiURL + url), httpOptions);
  }
  GetDept(url: any): Observable<Department[]> {
    return this.http.get<Department[]>((serviceConstants.apiURL + url), httpOptions);
  }

  //screen service methods
  screenUpdate(url: any, body: any): Observable<any> {
     ;
    return this.http.post(url, body, httpOptions);
  }

  screenInsert(url: any, body: any): Observable<any> {
     ;
    return this.http.post(url, body, httpOptions);
  }

  screenResponseInsert(url: any, response: any): Observable<any> {
     ;
    return this.http.post(url, response, formOptions);
  }
  screenResponseUpdate(url: any, response: SCREEN_RESPONSE[]): Observable<any> {
     ;
    return this.http.post(url, response, httpOptions);
  }

  screenControlsInsert(url: any, body: any): Observable<any> {
     ;
    return this.http.post(url, body, httpOptions);
  }
  setInActive(url: any): Observable<any> {
    return this.http.get((serviceConstants.apiURL + url), httpOptions);
  }

  setActive(url: any): Observable<any> {
    return this.http.get((serviceConstants.apiURL + url), httpOptions);
  }
  Delete(url: any): Observable<any> {
    return this.http.get((serviceConstants.apiURL + url), httpOptions);
  }
  DeleteDocument(url: any): Observable<any> {
     ;
    return this.http.get((serviceConstants.apiURL + url), httpOptions);
  }
  Insert(url: any, body: any): Observable<any> {
     ;
    return this.http.post((serviceConstants.apiURL + url), body, httpOptions);
  }

  chagnePassword(url: any,body:any): Observable<any> {
    return this.http.post((serviceConstants.apiURL + url),body, httpOptions);
    }
  forgotPassword(url: any,body:any): Observable<any> {
    return this.http.post((serviceConstants.apiURL + url),body, httpOptions);
  }
  InsertWithFiles(url: any, body: any): Observable<any> {
    return this.http.post((serviceConstants.apiURL + url), body, formOptions);
  }
 getModules(url: any){
  return this.http.get((serviceConstants.apiURL + url), httpOptions );
 }
  getRecord(url: any) {
     ;
    return this.http.get((serviceConstants.apiURL + url), httpOptions);
  }
  getSummaryData(url: any): Observable<any> {
    return this.http.get((serviceConstants.apiURL + url), formOptions);
  }

  getPolicySummaryData(model: PolicyModel): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/policy/GetNextStateName', model, httpOptions);
  }

    getModuleByOrgId(url: any): Observable<any> {
    return this.http.get((serviceConstants.apiURL + url), httpOptions);
  }

  getModuleList(url: any): Observable<any> {
    return this.http.get((serviceConstants.apiURL + url), httpOptions);
  }
  updateRecord(url: any): Observable<any> {
    return this.http.get((serviceConstants.apiURL + url), httpOptions);
  }
  getCurrencies(url: any): Observable<any> {
    return this.http.get((serviceConstants.apiURL + url), httpOptions);
  }

  AdvanceSearch(url: any, body: any) {
    return this.http.post((serviceConstants.apiURL + url), body, httpOptions);
  }
  GetMasterDocumentType(Url: any): Observable<any> {
    return this.http.get((serviceConstants.apiURL + Url), httpOptions);
  }
  GetMasterScreenData(Url: any): Observable<any> {
    return this.http.get((serviceConstants.apiURL + Url), httpOptions);
  }
  //end screen service methods

  // RFI
  getRFIByID(url): Observable<any> {
    return this.http.get(serviceConstants.apiURL + url, httpOptions)
  }
  addRFI(obj): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/rfi/insert', obj, httpOptions)
  }

  addRFIComment(obj): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/rfi/insertcomment', obj, formOptions)
  }


  editRFI(_id, obj): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/rfi/update', obj, httpOptions)
  }

  getRFI(name, appid): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/rfi/getrfis/' + name +'/'+ appid, httpOptions);
  }

  getRFIAdvSearch(searchObject: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/rfi/getadvsearch', searchObject, httpOptions);
  }

  deleteRFI(id, module): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/rfi/delete/' + id +"/" + module, httpOptions);
  }

  closeRFI(id, module): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/rfi/close/' + id + "/" + module, httpOptions);
  }

  // Notes
  getNotesByID(url): Observable<any> {
    return this.http.get(serviceConstants.apiURL + url, httpOptions)
  }
  addNotes(obj): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/notes/insert', obj, httpOptions)
  }

  editNotes(_id, obj): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/notes/update', obj, httpOptions)
  }

  getNotes(name?, appid?): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/notes/getnotes/' + name + '/' + appid, httpOptions);
  }

  deleteNotes(id): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/notes/delete/' + id, httpOptions);
  }

  // FAQ
  // RFI
  getFAQByID(url): Observable<any> {
    return this.http.get(serviceConstants.apiURL + url, httpOptions)
  }
  addFAQ(obj): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/faq/insert', obj, httpOptions)
  }

  editFAQ(_id, obj): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/faq/update', obj, httpOptions)
  }

  getFAQ(name?): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/faq/getfaqs/' + name, httpOptions);
  }

  getAdvFAQ(searchObject: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/faq/getadvsearch', searchObject, httpOptions);
  }

  getAdvNotification(searchObject: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/notification/getadvsearch', searchObject, httpOptions);
  }

  deleteFAQ(id): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/faq/delete/' + id, httpOptions);
  }

  // Notificatin
  getNotification(searchObject: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/notification/getadvsearch', searchObject, httpOptions);
  }

  //Route
  getRouteHistory(url): Observable<any> {
    return this.http.get(serviceConstants.apiURL + url, httpOptions)
  }
  insertAutocode(obj: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/autocode/insert', obj, httpOptions)
  }
  updateAutocode(obj: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/autocode/update', obj, httpOptions)
  }

  insertLookups(obj: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/lookup/insertList', obj, httpOptions)
  }

  insert(obj: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/lookup/insert', obj, httpOptions)
  }

  insertHLookups(obj: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/lookup/hlookupinsert', obj, httpOptions)
  }

  updatHLookups(obj: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/lookup/UpdatHLookups', obj, httpOptions)
  }

  updateLookups(obj: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/lookup/updateLookups', obj, httpOptions)
  }

  update(obj: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/lookup/update', obj, httpOptions)
  }

  deleteLookups(obj: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/lookup/delete', obj, httpOptions)
  }

  updateHLookups(obj: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/lookup/hlookupsupdate', obj, httpOptions)
  }

  deleteHLookups(obj: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/lookup/hlookupsdelete', obj, httpOptions)
  }

  getConfiguration(url: any): Observable<any> {
    return this.http.get((serviceConstants.apiURL + url), httpOptions);
  }

  saveEmailconfiguration(obj: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/configuration/insertemail', obj, httpOptions)
  }

  saveLDAPconfiguration(obj: any): Observable<any> {
    return this.http.post((serviceConstants.apiURL + 'api/configuration/insertldap'), obj, formOptions)
  }

  saveSAMLconfiguration(obj: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/configuration/insertsaml', obj, httpOptions)
  }

  getEventParams(eventCode: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/common/geteventparams/' + eventCode, httpOptions);
  }

  sendMail(toaddres: string, eventCode: string, params: any): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/common/sendmail/' + toaddres + '/' + eventCode + '/' + params, httpOptions);
  }

  checkMandatoryFormFileds(appid: string, action: string, module: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/common/checkmandatory/' + appid + '/' + action + '/' + module, httpOptions)
  }

  savePolicy(obj: any,url:any): Observable<any> {
    return this.http.post(serviceConstants.apiURL +url, obj, httpOptions)
  }


  checkControlReference(id: any): Observable<any> {
     ;
    return this.http.get<any>(serviceConstants.apiURL + 'api/screen/CheckIsReferencedControl/'+ id, this.jsonOptions);
  }
  checkControlValueReference(controlId: any,value:any): Observable<any> {
     ;
    return this.http.get<any>(serviceConstants.apiURL + 'api/screen/CheckIsReferencedValues/'+ controlId+"/"+value, this.jsonOptions);
  }

  getEmailSetUpSummary(id: any): Observable<any> {
     ;
    return this.http.get<any>(serviceConstants.apiURL + 'api/EmailSetUP/Fetch/'+ id, this.jsonOptions);
  }
 
  // fgetEmailSetUpSearchData(configID: string): Observable<any> {
  //   return this.http.get<any>(serviceConstants.apiURL + 'api/EmailSetUP/Fetch/' + configID, this.jsonOptions);
  // }
  
  ValidateLogiConf(obj: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/organization/ValidateLogiConf', obj, httpOptions)
  }

  getRegistrationConfig(_id?): Observable<any> {
    if (_id)
      return this.http.get(serviceConstants.apiURL + 'api/RegistrationConfig/GetRegConfigSummaryById?Id=' +  _id, httpOptions);
    else
      return this.http.get(serviceConstants.apiURL + 'api/RegistrationConfig/FetchRegConfigSummary', httpOptions);
  }

  saveRegistrationConfig(obj: any): Observable<any> {     
    return this.http.post(serviceConstants.apiURL + 'api/RegistrationConfig/Update', obj, httpOptions)
  }  
  checkRegControlReference(id: any): Observable<any> {
     ;
    return this.http.get<any>(serviceConstants.apiURL + 'api/RegistrationConfig/CheckwheatherUsedorNot?CtrlId='+ id, httpOptions);
  }
  checkRegControlValueReference(controlId: any,value:any): Observable<any> {
     ;
    return this.http.get<any>(serviceConstants.apiURL + 'api/RegistrationConfig/CheckwheatherUsedorNot?CtrlId='+ controlId+"/"+value, httpOptions);
  }
  
  GetData(Url:string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + Url, httpOptions)
  }
  PostData(Url:string,Obj:any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + Url,Obj, httpOptions)
  }

  uploadFile(file: File, fileId: string = ''): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<any>(serviceConstants.apiURL + 'api/configuration/upload?id=' + (fileId || ''), formData, this.jsonOptions);
  }

}


export interface LookUp {
  Key?: number;
  Value?: string;
  Code?: string;
  Status?: boolean;
}

